import React, { useState, useEffect, useRef } from "react";
import userimg from "../../assets/user.png";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import axios from "axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import useSponsoredAds from "../../hook/useSponsoredAds";
import SponsoredAdCard from "../ads/SponsoredAdCard";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
// showSponsoredAds is opt-in: this sidebar is shared by many pages, but only the homepage is a
// documented "feed" ad placement (api/BUYER_AD_DELIVERY.md).
export default function Rightsidebar({ showSponsoredAds = false }) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [followers, setFollowers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1); // Track the current page
  const [hasMore, setHasMore] = useState(true); // Track if more data is available
  const [followings, setFollowings] = useState([]);
  const navigate = useNavigate(); // Navigation hook
  const { ads: sponsoredAds, trackEvent, viewRef, removeAd } = useSponsoredAds({
    placement: "feed",
    context: { page: "home" },
    count: 3,
    enabled: showSponsoredAds,
  });

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  // Function to fetch user profile and navigate to myprofile page
    const handleUsernameClick = async (userId) => {
      const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
      if (!token) {
        alert("You must be logged in to view the profile.");
        return;
      }
  
      try {
        // Fetch user profile using the API
        const response = await axios.get(
          `${API_BASE_URL}/user/profile?id=${userId}`,
          {
            headers: {
              "Content-Type": "application/json",
              token: token,
            },
          }
        );
  
        if (response.data.success) {
          console.log("User profile fetched successfully:", response.data.result);
  
          // Redirect to the myprofile page with the user ID
          navigate(`/myprofile/${userId}`);
        } else {
          console.error("Failed to fetch user profile:", response.data.message);
        }
      } catch (error) {
        console.error("Error fetching user profile:", error);
      }
    };
  // Pages already requested (in flight or done); StrictMode re-runs the mount effect in development
  const requestedPagesRef = useRef(new Set());

  // ✅ Fetch all friends and followers
  const fetchFollowers = async (page=1) => {
    if (requestedPagesRef.current.has(page)) return;
    requestedPagesRef.current.add(page);
    setLoading(true);
    setError(null);

    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"); // Assuming you store token in session storage

    const requestBody = {
      filters: {
        isNotFriends: true,   // ✅ Added isNotFriends filter
      },
            page: page,
      limit: 10
    };

    try {
      const response = await axios.post(
        `${API_BASE_URL}/user/get-all-users`,
        requestBody,
        {
          headers: {
            "token": `${token}`,
            "Content-Type": "application/json"
          }
        }
      );

      if (response.data.success) {
        const newFollowers = response.data.result.users;

        // Append new followers to the existing list, skipping anyone already shown
        setFollowers((prev) => {
          const shownIds = new Set(prev.map((u) => u.id));
          return [...prev, ...newFollowers.filter((u) => !shownIds.has(u.id))];
        });

        // Check if there are more followers to load
        if (newFollowers.length < 10) {
          setHasMore(false); // No more data if fewer than 10 items are returned
        }
      } else {
        requestedPagesRef.current.delete(page);
        setError("Failed to fetch followers.");
      }
    } catch (error) {
      requestedPagesRef.current.delete(page);
      console.error("❌ Error fetching followers:", error);
      setError("An error occurred while fetching followers.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFollowers(currentPage);
  }, [currentPage]);
  // ✅ Load more followers when "Show More" is clicked
  const loadMoreFollowers = () => {
    if (hasMore) {
      setCurrentPage((prevPage) => prevPage + 1); // Increment the page number
    }
  };

  // ✅ Function to send a friend request
const sendFriendRequest = async (userId) => {
  const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");

  if (!token) {
    console.error("No token found. Please log in.");
    return;
  }

  try {
    const response = await axios.post(
      `${API_BASE_URL}/friend/add-friend`,
      {
        status: "pending",      // ✅ Friend request status
        user_id: userId        // ✅ Target user ID
      },
      {
        headers: {
          "token": `${token}`,
          "Content-Type": "application/json"
        }
      }
    );

    if (response.data.success) {
      console.log("Friend request sent successfully:", response.data);
      
      // ✅ Optionally, update the UI to reflect the request status
      setFollowers((prev) =>
        prev.map((user) =>
          user.id === userId ? { ...user, isFriendRequestSent: true } : user
        )
      );
                  // window.location.reload();

    } else {
      console.error("Failed to send friend request:", response.data.message);
    }
  } catch (error) {
    console.error("❌ Error sending friend request:", error);
  }
};
const handleUnfollow = async (friendId) => {
  const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
  if (!token) return console.error("No token found, please log in.");
// ✅ Show confirmation popup
const isConfirmed = window.confirm("Are you sure you want to unfollow this user?");
if (!isConfirmed) return; // Stop execution if user cancels

  // ✅ Retrieve the user2id from sessionStorage
 
  try {
    const response = await fetch(`${API_BASE_URL}/friend/add-friend`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "token": `${token}`,
      },
      body: JSON.stringify({
        status: "deleted",    // ✅ Use "unfollow" status
        user_id: friendId,
      }),
    });

    if (response.data.success) {
      console.log(`Unfollowed user ID: ${friendId}`);

      setFollowers((prev) =>
        prev.map((user) =>
          user.id === friendId
            ? { ...user, isFriendRequestSent: false, friendshipStatus: false }
            : user
        )
      );
            window.location.reload();

    } else {
      console.error("Failed to unfollow user:", response.data.message);
    }
  } catch (error) {
    console.error("Error unfollowing user:", error);
  }
};
  return (
    <div className="right-sidebar-fixed">
      {/* Right Sidebar */}
      <aside className="rightsidebar w-[20%] bg-white p-3 hidden lg:block">
        <div
          className={` bg-white shadow-md transition-all duration-300 suggested-profiles ${isScrolled ? "top-0 mt-1" : "top-[115px]"
            }`}
          style={{
            position: "fixed",
            right: 0,
            marginTop: "0px",
            height: "100vh",
            // width: "auto",
            overflowY: "auto",
            // padding: "15px",
          }}
        >
          <h3 className="followers-title mb-4">Based on Your Followers</h3>

          {loading && currentPage === 1 ? (
            <p>Loading...</p>
          ) : error ? (
            <p className="text-red-500">{error}</p>
          ) : followers?.length > 0 ? (
<>
             { followers.map((user, index) => (
                <div key={index} className="followers flex items-center justify-between space-x-4 mb-4">
                  <div className="followers-title-content flex items-center">
                    <img
                      src={user.profile_picture_url || userimg}  // Use API profile image or fallback
                                    // src={user.profile_picture_url}

                      alt={user.username}
                      className="w-12 h-12 rounded-full"
                    />
                    <div className="ml-1">
                      <p className="text-[14px] font-semibold follower-title-name"    onClick={(e) => {
                                              e.stopPropagation(); // Prevents the parent button's onClick
                                              handleUsernameClick(
                                                user?.id
                                              );
                                            }}>{user.first_name} {user.last_name}</p>

                      {/* <p className="titlesemibold font-semibold">{user.username}</p> */}
                      <p className="members text-sm text-gray-500 flex items-start gap-1"><span>{user.followersCount}</span><span> followers</span></p>
                    </div>
                  </div>
                 {/* ✅ Follow Button */}
                 <button
                   type="button" // ✅ Prevents default form behavior

                    onClick={() =>
                      user.isFriendRequestSent || user.friendshipStatus
                        ? handleUnfollow(user.id)
                        : sendFriendRequest(user.id)
                    }
                    className={`follow-cta px-4 py-1 rounded-lg ${
                      user.isFriendRequestSent || user.friendshipStatus
                        ? "bg-gray-400 text-white"
                        : "bg-blue-500 text-white"
                    }`}
                  >
                    {user.isFriendRequestSent || user.friendshipStatus
                      ? "Unfollow"
                      : "Follow"}
                  </button>
                </div>
              ))}
              {hasMore && (
                <p
                  onClick={loadMoreFollowers}
                  className="text-black-500 text-center cursor-pointer mt-4"
                  disabled={loading}
                >
                  {loading ? "Loading..." : "Show More"}
                </p>
              )}
            </>
          ) : (
            <p>No followers found.</p>
          )}

          <hr className="my-4" />
          <h3 className="followers-title font-semibold mt-6 mb-4">Based on Your Groups</h3>
          {loading ? (
            <p>Loading...</p>
          ) : (
            followers?.length > 0 ? (
              followers.slice(0, 5).map((group, index) => (
                <div key={index} className="followers followers-title-content flex items-center justify-between space-x-4 mb-4">
                  <div className="flex items-center">
                    <img
                      src={group.profile_picture_url || userimg}
                      alt={group.username}
                      className="w-12 h-12 rounded-full"
                    />
                    <div className="ml-1">
                      <p className="follower-title-name titlesemibold font-semibold">{group.username}</p>
                      <p className="members text-sm text-gray-500 flex items-start gap-1"><span>{group.followersCount}</span><span> followers</span></p>
                    </div>
                  </div>
                   <button
          type="button"
          onClick={() =>
            group.isFriendRequestSent || group.friendshipStatus
              ? handleUnfollow(group.id)
              : sendFriendRequest(group.id)
          }
          className={`follow-cta px-4 py-1 rounded-lg ${
            group.isFriendRequestSent || group.friendshipStatus
              ? "bg-gray-400 text-white"
              : "bg-blue-500 text-white"
          }`}
        >
          {group.isFriendRequestSent || group.friendshipStatus
            ? "Unfollow"
            : "Follow"}
        </button>
        
                </div>
              ))
            ) : (
              <p>No groups found.</p>
            )
          )}

          {sponsoredAds.length > 0 && (
            <>
              <hr className="my-4" />
              {sponsoredAds.map((ad) => (
                <SponsoredAdCard
                  key={ad.trackingId}
                  ad={ad}
                  onClick={trackEvent}
                  viewRef={viewRef(ad)}
                  onHidden={() => removeAd(ad.trackingId)}
                />
              ))}
            </>
          )}
        </div>
      </aside>
    </div>
  );
}
